/*
 * @Description: user actions
 */
import { ActionTree, ActionContext } from 'vuex'
import { RootState } from '@/store'
import { Mutations } from './mutations'
import { PortalActionTypes } from './action-types'
import { getPortalInfo } from "@/apis/commonApi";
import { PortalMutationTypes } from './mutation-types'
import { PortalState } from './state'


type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>
} & Omit<ActionContext<PortalState, RootState>, 'commit'>

export interface Actions {
  [PortalActionTypes.ACTION_GET_PORTAL_INFO](
    { commit }: AugmentedActionContext
  ): void;
}

export const actions: ActionTree<PortalState, RootState> & Actions = {
  async [PortalActionTypes.ACTION_GET_PORTAL_INFO](
      { commit }: AugmentedActionContext
  ) {
    await getPortalInfo().then((data) => {
      commit(PortalMutationTypes.SET_PORTAL_INFO, data)
      return data
    })
  },
}
